import { Theme, useTheme } from '@mui/material';
import Badge from '@mui/material/Badge';
import { makeStyles } from 'tss-react/mui';
import { FC } from 'react';
import { BadgeIconProps, BadgeShape, IconType } from './badgeIcon.types';
import ConnectivityIcon from '../ConnectivityIcon/ConnectivityIcon';

const BadgeIcon: FC<React.PropsWithChildren<BadgeIconProps>> = ({
  overlap,
  systemByOxBadge,
  badgeStatus,
  productionStage,
  badgeIcon: BadgeIcon,
  alt,
  marginX = 0,
  marginY = 0,
  badgeShape,
  innerIconHeight = 30,
}) => {
  const theme = useTheme();
  const { classes } = useStyles();
  const innerDivClassname =
    badgeShape === BadgeShape.Rectangle
      ? classes.rectangle
      : classes.badgeWrapper;

  return (
    <Badge
      badgeContent={
        badgeStatus ? <ConnectivityIcon type={badgeStatus} /> : null
      }
      overlap={overlap || 'circular'}
      sx={{
        '& .MuiBadge-badge': { pointerEvents: 'none' },
        margin: theme.spacing(marginY, marginX),
      }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}>
      <Badge
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{ '& .MuiBadge-badge': { pointerEvents: 'none' } }}
        badgeContent={
          systemByOxBadge ? (
            <ConnectivityIcon type={IconType.SystemByOx} />
          ) : null
        }
        overlap={overlap || 'circular'}>
        <Badge
          badgeContent={
            productionStage ? <ConnectivityIcon type={productionStage} /> : null
          }
          sx={{ '& .MuiBadge-badge': { pointerEvents: 'none' } }}
          overlap={overlap || 'circular'}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}>
          <div className={innerDivClassname}>
            {typeof BadgeIcon === 'string' ? (
              <img
                src={BadgeIcon}
                alt={alt}
                style={{ height: innerIconHeight, width: 'auto' }}
              />
            ) : (
              <BadgeIcon
                style={{ height: innerIconHeight, width: 'auto', maxWidth: 50 }}
              />
            )}
          </div>
        </Badge>
      </Badge>
    </Badge>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  rectangle: {
    display: 'inline-block',
    padding: 4,
  },
  badgeWrapper: {
    padding: 4,
    display: 'flex',
  },
}));

export default BadgeIcon;
